<app-breadcrumb [title]="'Съобщения'" [items]="['Email']" [active_item]="'съобщения'"></app-breadcrumb>

<div class="container-fluid">
  <div class="email-wrap">
    <div class="row">
      <div class="col-xl-3 col-md-6 xl-30 box-col-30">
        <app-email-filter
          (navigate)="onNavigate($event)"
          (navigateToFolder)="onNavigateToFolder($event)"
          (openFolderManagement)="openFolderManagementModal()"
          [NotReadCount]="totalUnreadCount"
          [readCount]="totalReadCount"
          [starredCount]="starredCount()"
          [starredApplicationsCount]="starredApplicationsCount()"
          [starredOthersCount]="starredOthersCount()"
          [inboxCount]="totalCount"
          [outBoxCount]="outBoxItems.length"
          [customFolders]="customFolders"
          [selectedFolderId]="selectedFolderId">
        </app-email-filter>
      </div>
      <div class="col-xl-9 col-md-12 xl-70 box-col-70">
        <div class="email-right-aside">
          <div *ngIf="isLoaded" class="card email-body">
            <div class="email-profile">
              <div>
                <div class="pe-0 b-r-light"></div>
                <div class="email-top">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1">
                          <div class="dropdown">
                            <button class="btn btn-primary dropdown-toggle" id="dropdownMenuButton" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="openMenu()">Действия</button>
                            <div class="dropdown-menu" [class.show]="show" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" (click)="loadData()" href="javascript:void(0)">
                                <i class="fa fa-refresh me-2"></i>Refresh
                              </a>
                            </div>
                          </div>
                        </div>
                        <!-- Classification Filter -->
                        <div class="ms-3">
                          <div class="btn-group classification-filter" role="group" aria-label="Филтър по класификация">
                            <button type="button"
                                    class="btn btn-light classification-filter-btn"
                                    [class.active]="currentClassificationFilter === MailClassificationFilter.All"
                                    (click)="onClassificationFilterChange(MailClassificationFilter.All)">
                              <i class="fa fa-list me-1"></i>Всички
                            </button>
                            <button type="button"
                                    class="btn btn-light classification-filter-btn"
                                    [class.active]="currentClassificationFilter === MailClassificationFilter.Zayavlenie"
                                    (click)="onClassificationFilterChange(MailClassificationFilter.Zayavlenie)">
                              <i class="fa fa-file-text me-1"></i>Заявления
                            </button>
                            <button type="button"
                                    class="btn btn-light classification-filter-btn"
                                    [class.active]="currentClassificationFilter === MailClassificationFilter.Other"
                                    (click)="onClassificationFilterChange(MailClassificationFilter.Other)">
                              <i class="fa fa-envelope me-1"></i>Други
                            </button>
                          </div>
                        </div>

                        <!-- Sort Dropdown -->
                        <div class="ms-3">
                          <div class="dropdown sort-dropdown">
                            <button class="btn btn-light dropdown-toggle sort-dropdown-btn" id="sortDropdownButton" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="openSortMenu()">
                              <i class="fa fa-sort me-2"></i>{{ getSortLabel(currentSortOption) }}
                            </button>
                            <div class="dropdown-menu dropdown-menu-end sort-dropdown-menu" [class.show]="showSortMenu" aria-labelledby="sortDropdownButton">
                              <h6 class="dropdown-header">Сортиране по:</h6>
                              <a class="dropdown-item"
                                 [class.active]="currentSortOption === mailSortOption.DateNewest"
                                 (click)="onSortChange(mailSortOption.DateNewest)"
                                 href="javascript:void(0)">
                                <i class="fa fa-calendar me-2"></i>{{ getSortLabel(mailSortOption.DateNewest) }}
                              </a>
                              <a class="dropdown-item"
                                 [class.active]="currentSortOption === mailSortOption.DateOldest"
                                 (click)="onSortChange(mailSortOption.DateOldest)"
                                 href="javascript:void(0)">
                                <i class="fa fa-calendar-o me-2"></i>{{ getSortLabel(mailSortOption.DateOldest) }}
                              </a>
                              <div class="dropdown-divider"></div>
                              <a class="dropdown-item"
                                 [class.active]="currentSortOption === mailSortOption.SenderAZ"
                                 (click)="onSortChange(mailSortOption.SenderAZ)"
                                 href="javascript:void(0)">
                                <i class="fa fa-sort-alpha-asc me-2"></i>{{ getSortLabel(mailSortOption.SenderAZ) }}
                              </a>
                              <a class="dropdown-item"
                                 [class.active]="currentSortOption === mailSortOption.SenderZA"
                                 (click)="onSortChange(mailSortOption.SenderZA)"
                                 href="javascript:void(0)">
                                <i class="fa fa-sort-alpha-desc me-2"></i>{{ getSortLabel(mailSortOption.SenderZA) }}
                              </a>
                              <div class="dropdown-divider"></div>
                              <a class="dropdown-item"
                                 [class.active]="currentSortOption === mailSortOption.SubjectAZ"
                                 (click)="onSortChange(mailSortOption.SubjectAZ)"
                                 href="javascript:void(0)">
                                <i class="fa fa-sort-alpha-asc me-2"></i>{{ getSortLabel(mailSortOption.SubjectAZ) }}
                              </a>
                              <a class="dropdown-item"
                                 [class.active]="currentSortOption === mailSortOption.SubjectZA"
                                 (click)="onSortChange(mailSortOption.SubjectZA)"
                                 href="javascript:void(0)">
                                <i class="fa fa-sort-alpha-desc me-2"></i>{{ getSortLabel(mailSortOption.SubjectZA) }}
                              </a>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!-- Multi-select toolbar -->
                  <div *ngIf="isMultiSelectMode && selectedNavigation != mailFilterNavigation.OutBox" class="multi-select-toolbar">
                    <div class="d-flex align-items-center">
                      <span class="me-3">
                        <strong>{{selectedMessageIds.size}}</strong> избрани
                      </span>
                      <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="selectAll()">
                        <i class="fa fa-check-square-o me-1"></i>Избери всички
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="clearSelection()">
                        <i class="fa fa-times me-1"></i>Отмени избора
                      </button>
                      <!-- Move to folder dropdown -->
                      <div class="dropdown">
                        <button class="btn btn-sm btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          <i class="fa fa-folder-open me-1"></i>Премести в папка
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a class="dropdown-item" (click)="moveMessagesToFolder(null)">
                              <i class="fa fa-inbox me-2"></i>Входящи
                            </a>
                          </li>
                          <li *ngIf="customFolders.length > 0"><hr class="dropdown-divider"></li>
                          <li *ngFor="let folder of customFolders">
                            <a class="dropdown-item" (click)="moveMessagesToFolder(folder.idMailFolder)">
                              <i class="fa fa-folder me-2"></i>{{folder.name}}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="inbox" style="padding-top:20px;">
                    <ng-container *ngIf="!emails || emails.length ==0">
                      <div class="d-flex">
                        <div>Няма постъпили мейли в системата</div>
                      </div>
                    </ng-container>
                    <!-- Display for Inbox and all inbox-based filters (Starred, UnRead, Read) -->
                    <ng-container *ngIf="selectedNavigation != mailFilterNavigation.OutBox && emails && emails.length > 0">
                      <div class="email-card" [class.selected]="isMessageSelected(email.id)" *ngFor="let email of emails" (dblclick)="openDetails(email)">
                        <div class="email-card-header">
                          <!-- Checkbox for selection -->
                          <div class="email-checkbox" (click)="$event.stopPropagation()">
                            <input type="checkbox"
                                   class="form-check-input"
                                   [checked]="isMessageSelected(email.id)"
                                   (change)="toggleMessageSelection(email.id)">
                          </div>
                          <div class="email-sender">{{email.senderProfileName || 'Неизвестен подател'}}</div>
                          <div class="email-actions">
                            <i *ngIf="!email.liked" (click)="setStar(email); $event.stopPropagation()" class="fa fa-star-o star-icon"></i>
                            <i *ngIf="email.liked" (click)="setStar(email); $event.stopPropagation()" class="fa fa-star star-icon starred"></i>
                            <!-- 3-dots menu -->
                            <div class="dropdown email-menu" (click)="$event.stopPropagation()">
                              <i class="fa fa-ellipsis-v menu-icon" data-bs-toggle="dropdown" data-bs-boundary="viewport" data-bs-strategy="fixed" aria-expanded="false"></i>
                              <ul class="dropdown-menu dropdown-menu-end">
                                <!-- Classify option - only for unclassified emails -->
                                <li *ngIf="!email.emailClassification">
                                  <a class="dropdown-item"
                                     [class.disabled]="isClassifying(email)"
                                     (click)="classifyEmail(email)">
                                    <i *ngIf="!isClassifying(email)" class="fa fa-magic me-2"></i>
                                    <i *ngIf="isClassifying(email)" class="fa fa-spinner fa-spin me-2"></i>
                                    <span *ngIf="!isClassifying(email)">Класифицирай</span>
                                    <span *ngIf="isClassifying(email)">Класифициране...</span>
                                  </a>
                                </li>
                                <!-- Change Classification option - for all emails -->
                                <li>
                                  <a class="dropdown-item" (click)="openChangeClassificationModal(email)">
                                    <i class="fa fa-edit me-2"></i>
                                    <span>Промени Класификация</span>
                                  </a>
                                </li>
                                <li><hr class="dropdown-divider"></li>
                                <!-- Move to folder - opens modal -->
                                <li>
                                  <a class="dropdown-item" (click)="openMoveToFolderModal(email)">
                                    <i class="fa fa-folder-open me-2"></i>Премести в папка
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="email-subject">{{email.subject}}</div>
                        <div class="email-footer">
                          <div class="email-date">{{formatDate(email.dateSent) || 'Няма дата'}}</div>
                          <span class="classification-badge" [ngClass]="getClassificationBadgeClass(email)">
                            <i class="fa fa-tag me-1"></i>{{getClassificationLabel(email)}}
                          </span>
                        </div>
                        <!-- Error message for classification failures -->
                        <div *ngIf="getClassificationError(email)" class="email-error">
                          <i class="fa fa-exclamation-circle me-1"></i>{{getClassificationError(email)}}
                        </div>
                      </div>
                    </ng-container>
                    <!-- Display for OutBox -->
                    <ng-container *ngIf="selectedNavigation == mailFilterNavigation.OutBox && emails && emails.length > 0">
                      <div class="email-card" *ngFor="let email of emails" (dblclick)="openDetails(email)">
                        <div class="email-card-header">
                          <div class="email-sender">До: {{email.recipients || 'Неизвестен получател'}}</div>
                        </div>
                        <div class="email-subject">{{email.subject}}</div>
                        <div class="email-date">{{formatDate(email.dateSent) || 'Няма дата'}}</div>
                      </div>
                    </ng-container>

                    <!-- Pagination Controls -->
                    <div class="pagination-container" *ngIf="selectedNavigation != mailFilterNavigation.OutBox && totalPages > 0">
                      <div class="pagination-left">
                        <div class="pagination-info">
                          Показване на {{getStartItem()}}-{{getEndItem()}} от {{totalCount}}
                        </div>
                        <div class="page-size-selector">
                          <select class="form-select form-select-sm page-size-select"
                                  [ngModel]="pageSize"
                                  (ngModelChange)="onPageSizeChange($event)">
                            <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{option}}</option>
                          </select>
                          <span class="page-size-label">на стр.</span>
                        </div>
                      </div>
                      <nav aria-label="Навигация по страници" *ngIf="totalPages > 1">
                        <ul class="pagination">
                          <li class="page-item" [class.disabled]="currentPage === 1">
                            <a class="page-link" (click)="onPageChange(currentPage - 1)" href="javascript:void(0)">
                              <i class="fa fa-chevron-left"></i>
                            </a>
                          </li>
                          <li class="page-item" *ngFor="let page of getPageNumbers()" [class.active]="page === currentPage">
                            <a class="page-link" (click)="onPageChange(page)" href="javascript:void(0)">{{page}}</a>
                          </li>
                          <li class="page-item" [class.disabled]="currentPage === totalPages">
                            <a class="page-link" (click)="onPageChange(currentPage + 1)" href="javascript:void(0)">
                              <i class="fa fa-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isLoaded" class="card email-body">
            <div class="spinner-grow spinner-grow-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>

            <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>

            <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>

            <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
      </div>
        </div>
  </div>
</div>
